import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { costBreakdownWidgetCostsSelector } from "./costBreakdownWidgetCostsSelector";

export const costBreakdownWidgetTotalCostSelector = createDraftSafeSelector(
  [costBreakdownWidgetCostsSelector],
  (costs) => {
    return costs.total;
  },
);
